/**
 * サンプルクラス
 * @constructor
 */
class Nav {
  constructor() {
    this.ww = window.innerWidth;
    this.bp = 750;
  }


  /**
   * サンプル
   */
  init() {
    $(window).on('resize load',()=>{
      this.ww = window.innerWidth;
      this.responsiveSwitch()
    })
    $('.l-headerList__item.is-gnav,.l-headerOv').on('mouseenter',()=>{
      this.megaNavOpen();
    });
    $('.l-headerList__item.is-gnav,.l-headerOv').on('mouseleave',()=>{
      this.megaNavClose();
    });
    $('.l-header__menu').on('click',(e)=>{
      this.spNavOpen(e.currentTarget);
    })
    $('.l-footerTopList__itemTtl').on('click',(e)=>{
      this.spFooterToggle(e.currentTarget);
    })
  }
  megaNavOpen(){
    $('.l-headerOv').addClass('is-active');
  }
  megaNavClose(){
    $('.l-headerOv').removeClass('is-active');
  }
  spNavOpen(el){
    if($(el).hasClass('is-active')){
      //閉じる
      $(el).removeClass('is-active');
      $('.l-header__block').removeClass('is-active');
    }else{
      //開く
      $(el).addClass('is-active');
      $('.l-header__block').addClass('is-active');
    }
  }
  spFooterToggle(el){
    if($(el).hasClass('is-active')){
      $(el).removeClass('is-active');
      $(el).next('.l-footerTopList__itemInner').slideUp(400);
    }else{
      $(el).addClass('is-active');
      $(el).next('.l-footerTopList__itemInner').slideDown(400);
    }
  }
  responsiveSwitch(){
    if(this.ww > this.bp){
      $('.l-footerTopList__itemInner').removeAttr('style');
    }
  }
};

export default Nav;
